import { APIcaller } from './APIcaller';

const getCentralKitchenProductionPlanning = (storeId, startDate, endDate) =>
  APIcaller.apiPost('/production/central-kitchen/production-planning', {
    storeId,
    startDate,
    endDate,
  });

const getCentralKitchenRecipesOfStore = (storeId, startDate, endDate) =>
  APIcaller.apiPost(`/production/central-kitchen/recipes`, {
    storeId,
    startDate,
    endDate,
  });

const getCentralKitchenRecipesConsumptions = (
  productionStoreId,
  consumptionStoreIds,
  startDate,
  endDate,
  entityIds,
) =>
  APIcaller.apiPost(`/production/central-kitchen/consumption-forecast`, {
    productionStoreId,
    consumptionStoreIds,
    startDate,
    endDate,
    entityIds,
  });

const upsertCentralKitchenProductionPlanning = (
  storeId,
  entityId,
  productionDate,
  quantity,
  userId,
) =>
  APIcaller.apiPost(`/production/central-kitchen/production-planning/${storeId}`, {
    entityId,
    productionDate,
    quantity,
    userId,
  });

const upsertCentralKitchenProductionPlanningByBatch = (productionPlannings) =>
  APIcaller.apiPost(`/production/central-kitchen/batch/production-planning`, {
    productionPlannings,
  });

const getProductionPlanning = (
  storeId,
  { startDate, endDate, categoryIds, includeProductionMininum },
) =>
  APIcaller.apiPost(`/production/stores/${storeId}/production-planning`, {
    startDate,
    endDate,
    categoryIds,
    includeProductionMininum,
  });

const upsertProductionProductForecast = (storeId, productId, { date, tot, delta }) =>
  APIcaller.apiPost(`/production/stores/${storeId}/products/${productId}/product-forecast`, {
    date,
    tot,
    delta,
  });

// TODO INP-1644 Supprimer cette route
const downloadProductionPlanningPdf = (
  storeId,
  { startDate, endDate, categoryIds, productionDate, planningConfiguration },
) =>
  APIcaller.apiPost(`/production/stores/${storeId}/planning-pdf`, {
    startDate,
    endDate,
    categoryIds,
    productionDate,
    planningConfiguration,
  });

const getAggregatedProductForecast = (
  storeId,
  { startDate, endDate, categoryIds, includeProductionMininum },
) =>
  APIcaller.apiPost(`/production/stores/${storeId}/aggregated-product-forecast`, {
    startDate,
    endDate,
    categoryIds,
    includeProductionMininum,
  });

const postAdminProductForecast = (storeId, productId, { date, quantity, delta }) =>
  APIcaller.apiPost(`/production/admin-product-forecast`, {
    storeId,
    productId,
    date,
    quantity,
    delta,
  });

const downloadSalesPlanningPDF = (
  storeId,
  { startDate, endDate, categoryIds, withTimeSlots, planningConfiguration },
) =>
  APIcaller.apiPost(`/production/stores/${storeId}/sales-planning-pdf`, {
    startDate,
    endDate,
    categoryIds,
    withTimeSlots,
    planningConfiguration,
  });

const downloadProductForecastTemplate = ({ storeIds, categoryIds, startDate, endDate }) =>
  APIcaller.apiPost(
    `/production/product-forecast/import/template`,
    {
      storeIds,
      categoryIds,
      startDate,
      endDate,
    },
    'blob',
  );

const validateImportProductForecast = (importPayload) =>
  APIcaller.apiPost('/production/product-forecast/import/validate', importPayload, 'blob');

const importProductForecast = (importPayload) =>
  APIcaller.apiPost('/production/product-forecast/import', importPayload);

const getProductionEntries = (
  storeId,
  date,
  { categoryIds = [], noOperatorForecasts = false } = {},
) =>
  APIcaller.apiPost(`/production/production-entries`, {
    storeId,
    date,
    categoryIds,
    noOperatorForecasts,
  });

const postProductionEntry = (
  storeId,
  date,
  productId,
  productionTimeSlotId,
  { adminForecast, operatorForecast, inStock, produced, noOperatorForecasts = false } = {},
) =>
  APIcaller.apiPost(`/production/production-entry`, {
    storeId,
    date,
    productId,
    productionTimeSlotId,
    adminForecast,
    operatorForecast,
    inStock,
    produced,
    noOperatorForecasts,
  });

const postRecipeProductionEntry = (storeId, date, entityId, productionTimeSlotId, inStock) =>
  APIcaller.apiPost(`/production/recipe-production-entry`, {
    storeId,
    date,
    entityId,
    productionTimeSlotId,
    inStock,
  });

const resetProductionEntries = (storeId, productIds, date, isOperatorForecastReset = false) =>
  APIcaller.apiPost(`/production/reset-production-entries`, {
    storeId,
    productIds,
    date,
    isOperatorForecastReset,
  });

const fillProductionEntries = (
  storeId,
  date,
  productIds,
  { productionTimeSlotId = null, resetProduced = false } = {},
) =>
  APIcaller.apiPost('/production/fill-production-entries', {
    storeId,
    date,
    productIds,
    productionTimeSlotId,
    resetProduced,
  });

export default {
  getProductionPlanning,
  getCentralKitchenProductionPlanning,
  getCentralKitchenRecipesOfStore,
  getCentralKitchenRecipesConsumptions,
  upsertCentralKitchenProductionPlanning,
  upsertCentralKitchenProductionPlanningByBatch,
  upsertProductionProductForecast,
  downloadProductionPlanningPdf,
  getAggregatedProductForecast,
  postAdminProductForecast,
  downloadSalesPlanningPDF,
  downloadProductForecastTemplate,
  validateImportProductForecast,
  importProductForecast,
  getProductionEntries,
  postProductionEntry,
  postRecipeProductionEntry,
  resetProductionEntries,
  fillProductionEntries,
};
